import axios from "axios";
let burl = process.env.VUE_APP_API;
import {shieldHeaders} from "../http_common";

export function getOpcoByIdcc(idcc){
    return axios.get(burl + '/api/opco/?idcc=' + idcc,{
        headers : shieldHeaders
    });
}
